export class Consent {
  public facebookSocialPlugins: boolean = false;
  public googleAnalytics: boolean = false;
  public googleFonts: boolean = false;
  public googleMaps: boolean = false;
  public googleTagManager: boolean = false;
  public UsercentricsConsentManagementPlatform: boolean = false;
  public jquery: boolean = false;
}
